import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { SavePlayerInput_InputAdapter_instance3fw9b8k7xujxv as SavePlayerInput_InputAdapter_instance } from '../type/adapter/SavePlayerInput_InputAdapter.mjs';
import { obj2vqjd1bjrpmyg as obj } from '../../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/Adapters.mjs';
import { initMetadataForObject1cxne3s9w65el as initMetadataForObject } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var SavePlayerMutation_VariablesAdapterClass;
function SavePlayerMutation_VariablesAdapter() {
  if (SavePlayerMutation_VariablesAdapterClass === VOID) {
    class $ {
      serializeVariables_6d9ki5_k$(writer, value, customScalarAdapters, withDefaultValues) {
        writer.name_i73qwh_k$('input');
        obj(SavePlayerInput_InputAdapter_instance).toJson_h31rt1_k$(writer, customScalarAdapters, value.input_1);
      }
    }
    initMetadataForObject($, 'SavePlayerMutation_VariablesAdapter');
    SavePlayerMutation_VariablesAdapterClass = $;
  }
  return SavePlayerMutation_VariablesAdapterClass;
}
var SavePlayerMutation_VariablesAdapter_instance;
function SavePlayerMutation_VariablesAdapter_getInstance() {
  return SavePlayerMutation_VariablesAdapter_instance;
}
//region block: init
SavePlayerMutation_VariablesAdapter_instance = new (SavePlayerMutation_VariablesAdapter())();
//endregion
//region block: exports
export {
  SavePlayerMutation_VariablesAdapter_instance as SavePlayerMutation_VariablesAdapter_instance8tursi8i0zo0,
};
//endregion

//# sourceMappingURL=SavePlayerMutation_VariablesAdapter.mjs.map
